import { gql } from '@apollo/client';

export const DueDateFields = gql`
  fragment DueDateFields on DueDateConfiguration {
    type
    fixedType
    fixedDate
    rangeFrom
    rangeTo
    intervalDays
  }
`;

export const CbDeliverableV2Fields = gql`
  fragment CbDeliverableV2Fields on CbDeliverableV2 {
    id
    createdAt
    updatedAt
    status
    contentDueDateUtc
    contentDueDateFrom
    contentDueDateTo
    publishDueDateUtc
    publishDueDateFrom
    publishDueDateTo
    extendedPublishDays
    eventDueDate
    task {
      id
      type
      title
      description
      orderIdx
      suggestedCaption
      hashtags
      mentions
      tagAsCollab
      ... on CampaignContentTask {
        mediaType
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignIGLiveTask {
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignIGPostTask {
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignIGReelTask {
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignIGStoryTask {
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignTTVideoTask {
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignFinalContentTask {
        ctaTitle
        mediaTypes
        isBrandHidden
        dueDate {
          ...DueDateFields
        }
      }
      ... on CampaignAppearanceTask {
        appearanceType
        durationText
        location
        travelIncluded
        accommodationIncluded
        maxExpenses
        dueDate {
          ...DueDateFields
        }
      }
    }
    items {
      id
      type
      status
      taskId
      rejectCnt
      task {
        id
        type
        title
        suggestedCaption
        description
        orderIdx
        ... on CampaignContentTask {
          mediaType
        }
        ... on CampaignFinalContentTask {
          ctaTitle
          mediaTypes
          isBrandHidden
        }
      }
      ... on CbDeliverableFileItemV2 {
        key
        name
        url
      }
      ... on CbDeliverableCopyV2 {
        copy
      }
      ... on CbDeliverableLinkItemV2 {
        link
      }
      ... on CbDeliverableFilesItemV2 {
        files {
          key
          name
          type
          url
          videoTranscodingJobId
        }
      }
    }
    revisions {
      id
      createdAt
      isArchived
      performedById
      performedByEmail
      items {
        id
        type
        taskDescription
        taskTitle
        feedback
        itemId
      }
    }
  }
  ${DueDateFields}
`;
